import { useState } from 'react';

/**
 * Hook to manage modal state for AllQueries page
 * @returns {Object} Modal state and handlers
 */
export const useAllQueriesPageModals = () => {
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [escalatingId, setEscalatingId] = useState(null);
  const [escalateDialogOpen, setEscalateDialogOpen] = useState(false);
  const [escalateTarget, setEscalateTarget] = useState(null);

  const handleOpenViewModal = (query) => {
    setSelectedQuery(query);
    setViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setViewModalOpen(false);
    setSelectedQuery(null);
  };

  const handleOpenEditModal = (query) => {
    setSelectedQuery(query);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedQuery(null);
  };

  const handleOpenDeleteDialog = (query) => {
    setSelectedQuery(query);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setSelectedQuery(null);
  };

  const handleOpenEscalateDialog = (query) => {
    setEscalateTarget(query);
    setEscalateDialogOpen(true);
  };

  const handleCloseEscalateDialog = () => {
    if (escalatingId === escalateTarget?._id) return;
    setEscalateDialogOpen(false);
    setEscalateTarget(null);
  };

  return {
    viewModalOpen,
    editModalOpen,
    deleteDialogOpen,
    selectedQuery,
    escalatingId,
    escalateDialogOpen,
    escalateTarget,
    setViewModalOpen,
    setEditModalOpen,
    setDeleteDialogOpen,
    setSelectedQuery,
    setEscalatingId,
    setEscalateDialogOpen,
    setEscalateTarget,
    handleOpenViewModal,
    handleCloseViewModal,
    handleOpenEditModal,
    handleCloseEditModal,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    handleOpenEscalateDialog,
    handleCloseEscalateDialog,
  };
};
